var render = function render(){var _vm=this,_c=_vm._self._c;return _c('option',_vm._b({attrs:{"checked":_vm.checked}},'option',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }